<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="examIng_back"></div>
		<div class="examIng_head">
			<div class="examIng_headTitle">
				{{taskinfo.name}}
			</div>
			<div class="examIng_headTime">
				<span>共{{topicinfo.topicAmount}}道题，总分{{topicinfo.totalScore}}分</span>
			</div>
			<div class="exam_exit" @click="$router.back(-1)">返回</div>
			<div class="exam_exit error" @click="representate = true" v-show="recordinfo.representationStatus !='1'">申诉</div>
		</div>
		<div class="content minheight examIng_body clearfix ">
			<div class="examIng_left">
				<div class="examIng_infoHead">答题卡</div>
				<div class="examIng_infobodyList">
					<div class="examIng_infobodyTitle">
						当前成绩：<span class="warningColor">{{userScore || "0"}}</span>
					</div>
					<div class="examIng_infobodyType success">正确</div>
					<div class="examIng_infobodyType error">错误</div>
					<div class="examIng_infobodyType warning">简答已批</div>
					<div class="examIng_infobodyType info">简答未批</div>
				</div>
				<div class="examIng_infobody examIng_infobodyLow clearfix">
					<div class="questionAnswer" :class="questionStatus(item,index)" v-for="(item,index) in qusetionlist" @click="jumpQuestion(index,'jump')">
						{{index+1}}
					</div>
				</div>
			</div>
			<div class="examIng_right">
				<div class="examIng_infoHead" v-show="questionindex == index" v-for="(item,index) in qusetionlist">
					<span v-if="item.topicType == 1">单选题</span>
					<span v-if="item.topicType == 2">多选题</span>
					<span v-if="item.topicType == 3">判断题</span>
					<span v-if="item.topicType == 4">填空题</span>
					<span v-if="item.topicType == 5">简答题</span>
					<span class="examIng_score warningColor">（{{item.score}}分，{{item.userScore!=null?'得分'+item.userScore:'未批改'}}）</span>
				</div>
				<div class="examQuestion_infobody clearfix">
					<questions :questionsubmit='false' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
				</div>
				<div class="examIng_infoFoot">
					<el-button @click="jumpQuestion(questionindex-1,'prve')" :disabled='questionindex<=0'>上一题</el-button>
					<el-button @click="jumpQuestion(questionindex+1,'next')" type="primary" :disabled='questionindex>=qusetionlist.length-1'>下一题</el-button>
				</div>
			</div>
		</div>

		<el-dialog title="提交申诉" width='500px' :visible.sync="representate">
			<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="representation">
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="representateAdd" :disabled='dataloading'>确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getRecordInfo, getExamineById, addRepresentation } from '@/api/examine.js'
	import { collectionSave, collectionDelete } from '@/api/collection'
	import questions from '@/components/questions.vue'
	import questionsjs from '@/components/questions.js'
	export default {
		name: 'taskdetails',
		mixins: [questionsjs],
		components: {
			questions
		},
		data() {
			return {
				id: this.$route.query.id,
				userScore: 0,
				rightNum: 0,
				loading: true,
				loadingtext: '题目加载中...',
				questionindex: 0,
				testinfo: [],
				qusetionlist: [],
				taskinfo: {},
				topicinfo: {},
				recordinfo: {},
				//申诉
				dataloading: false,
				representation: '',
				representate: false,
			}
		},
		created() {
			this.getTaskinfo();
			this.getTaskitem();
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			representateAdd() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(this.representation != '') {
					var data = {
						examineId: this.taskinfo.id,
						examineName: this.taskinfo.name,
						paperId: this.topicinfo.id,
						recordId: this.recordinfo.id,
						representation: this.representation,
					}
					addRepresentation(data).then(res => {
						if(res.code == "OK") {
							this.$message.success('申诉成功,可在个人中心查看')
							this.recordinfo.representationStatus = '1';
							this.representation = '';
							this.representate = false;
						} else {
							this.$message.error('申诉失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}

			},
			getTaskitem() {
				var data = {
					id: this.id
				}
				getExamineById(data).then(res => {
					if(res.code == "OK" && res.data) {
						this.taskinfo = res.data;
						res.data.paperList.map(item => {
							if(item.isUsing == '1') {
								this.topicinfo = item;
							}
						})
					}
				})
			},
			getTaskinfo() {
				var data = {
					examId: this.id
				}
				getRecordInfo(data).then(res => {
					if(res.code == "OK") {
						var data = res.data;
						this.recordinfo = data;
						this.userScore = data.score;
						this.rightNum = data.rightNum;
						var userAnswers = data.examineRecordDetail;
						var qusetionlist = [];
						userAnswers.map(item => {
							var qusetionitem = Object.assign({}, item, item.examineTopic)
							qusetionitem.recoreId = item.id;
							qusetionitem.userScore = item.score;
							qusetionlist.push(qusetionitem)
						})
						this.qusetionlist = qusetionlist;
						this.formInitOver()
					}
				})
			},
			jumpQuestion(questionindex) {
				if(this.questionindex != questionindex) {
					this.questionindex = questionindex
				}
			},
		},
	}
</script>